//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapState, mapActions, mapGetters} from 'vuex';
import httpExercisesBasket from '@/fetch/http-exercises-basket';
import * as types from '../../vuex/types'
import Vue from 'vue'

export default {
  name: 'headerBar',
  data() {
    return {
      innerHeight:1080,
      exerCount: 0,
      exerFacility: 0,
      exerBasketList:[],
      exerBankList:[],
      paperTypeList:[],
      showBankFlag:false,
      showPaperFlag:false,
      chooseCourseId:'',
      chooseCourseName:'',
      chooseCourseNameTitle:'',
      bankId:'',
      bankName:'',
      activeTap:true,
      paperName:'',
      paperType:''
    };
  },
  computed: {
    ...mapState({
      exerciseCount: state => state.status.exerciseCount,
      clickExerBasketFlag: state => state.status.clickExerBasketFlag
    })
  },
  watch: {
      activeTap() {
        this.bankId = '';
      }
  },
  methods: {
    ...mapActions({
      setExerciseCount: 'setExerciseCount',
      setClickExerBasketFlag: 'setClickExerBasketFlag'
    }),
    courseTypeName(type) {
      if (type == "1") {
        return "基础课程";
      } else if (type == "2") {
        return "专业课程";
      } else if (type == "3") {
        return "考证";
      }
      return type;
    },
    bindBank(){
      if (this.bankId == '' && this.activeTap) {
        this.$toast({
          message: '请选择题库',
          position: "bottom",
          duration: 3000,
          className: 'toastWhite'
        });
        return;
      }
      if (this.bankName == '' && !this.activeTap) {
        this.$toast({
          message: '请输入题库名称',
          position: "bottom",
          duration: 3000,
          className: 'toastWhite'
        });
        return;
      }
      var param = {
        courseId:this.chooseCourseId,
        bankName:this.bankName,
        bankId:this.bankId
      }
      httpExercisesBasket.chooseBank(param).then(res => {
        if (res.msgCode == types.STATUS_OK) {
          this.getBasketList();
          this.setExerciseCount();
          this.showBankFlag = false;
          this.setClickExerBasketFlag(false)
            this.$totast("添加题库成功。");
        } else {
          this.$totast("添加题库失败。");
        }
      });
    },
    submitPaper(){
      var param = {
        name:this.paperName,
        typeId:this.paperType
      }
      httpExercisesBasket.createExerciseBasketPaper(param).then(res => {
        if (res.msgCode == 1) {
          httpExercisesBasket.deleteExerBasketAll()
            .then(res => {
              if (res.msgCode == types.STATUS_OK) {
                this.getBasketList();
                this.setExerciseCount();
                this.showPaperFlag = false;
                this.setClickExerBasketFlag(false);
                this.paperName = '';
                this.paperType = '';
                this.$emit('changeClickExerBasketFlag', false);
              }
            })
          this.$router.push({
            path: '/paperView',
            query: {id: res.data.id, courseId: res.data.courseId, schoolId: this.schoolId, basketFlag: true,level:3}
          });
        } else {
          this.$toast({
            message: res.msg,
            position: "bottom",
            duration: 3000
          });
        }
      });
    },
    toPaper(){
      this.showPaperFlag = true;
      this.getPaperTypeList();
    },
    cancel(){
      this.showBankFlag = false;
      this.showPaperFlag = false;
      this.chooseCourseName = '';
      this.chooseCourseId = '';
    },
    addExerBank(item) {
      this.bankId = '';
      this.showBankFlag = true;
      this.chooseCourseId = item.courseId;
      this.chooseCourseNameTitle = item.courseName+"-题库名称";
      if (item.courseName.length < 13) {
        this.chooseCourseName = item.courseName;
      } else {
        this.chooseCourseName = item.courseName.substring(0,12)+"...";
      }
      this.getBankList(item.courseId);
    },
    deleteMultiple(typeId,courseId) {
      this.$alert('确定将试题移除试题篮吗？', '移除试题？', {
        confirmButtonText: '确定',
        cancelButtonText:'取消',
        showCancelButton: true,
        showConfirmButton: true,
        callback: (action) => {
          if (action == "confirm") {
            httpExercisesBasket.deleteExerBasketMultiple(typeId,courseId)
              .then(res => {
                if (res.msgCode == types.STATUS_OK) {
                  this.getBasketList();
                  this.setExerciseCount();
                  this.$toast({
                    message: '删除成功',
                    position: "bottom",
                    duration: 3000,
                    className: 'toastWhite'
                  });
                }
              })
          }
        }
      });
    },
    deleteAll() {
      this.$alert('确定将试题移除试题篮吗？', '移除试题？', {
        confirmButtonText: '确定',
        cancelButtonText:'取消',
        showCancelButton: true,
        showConfirmButton: true,
        callback: (action) => {
          if (action == "confirm") {
            httpExercisesBasket.deleteExerBasketAll()
              .then(res => {
                if (res.msgCode == types.STATUS_OK) {
                  this.getBasketList();
                  this.setExerciseCount();
                  this.$toast({
                    message: '删除成功',
                    position: "bottom",
                    duration: 3000,
                    className: 'toastWhite'
                  });
                }
              })
          }
        }
      });
    },
    deleteOne(id) {
      this.$alert('确定将试题移除试题篮吗？', '移除试题？', {
        confirmButtonText: '确定',
        cancelButtonText:'取消',
        showCancelButton: true,
        showConfirmButton: true,
        callback: (action) => {
          if (action == "confirm") {
            httpExercisesBasket.deleteExerBasket(id)
              .then(res => {
                if (res.msgCode == types.STATUS_OK) {
                  this.getBasketList();
                  this.setExerciseCount();
                  this.$toast({
                    message: '删除成功',
                    position: "bottom",
                    duration: 3000,
                    className: 'toastWhite'
                  });
                }
              })
          }
        }
      });
    },
    clickExerBasketType(courseIndex,typeIndex){
      this.exerBasketList[courseIndex].exercisesBasketTypeWebDTO[typeIndex].showFlag = !this.exerBasketList[courseIndex].exercisesBasketTypeWebDTO[typeIndex].showFlag;
      Vue.set(this.exerBasketList,courseIndex,this.exerBasketList[courseIndex]);
    },
    clickExerBasket(){
      // 展开试题篮时查询
      if(this.clickExerBasketFlag) {
        this.getBasketList();
        this.setExerciseCount();
      }
      this.showBankFlag = false;
    },
    getBasketList(){
      httpExercisesBasket.getExerciseBasketsList().then(res => {
          if (res.msgCode == types.STATUS_OK) {
            this.exerCount = 0;
            this.exerFacility = 0;
            this.exerBasketList = res.data;
            this.exerBasketList.forEach(item =>{
              item.exercisesBasketTypeWebDTO.forEach(exerType =>{
                exerType.showFlag = false;
                exerType.exercisesBasketListWebDTO.forEach(exer=>{
                  this.exerCount++;
                  this.exerFacility = this.exerFacility + exer.facilityValue;
                })
              })
            });
            this.exerFacility = Math.round(this.exerCount != 0 ? this.exerFacility/this.exerCount:0);
          }
        }).catch(error => {
      })
    },
    getBankList(courseId){
      httpExercisesBasket.getExerciseBankList(courseId).then(res => {
          if (res.msgCode == types.STATUS_OK) {
            this.exerBankList = res.data;
          }
        }).catch(error => {
      })
    },
    getPaperTypeList(){
      httpExercisesBasket.getPaperTypeList().then(res => {
          if (res.msgCode == types.STATUS_OK) {
            this.paperTypeList = res.data;
          }
        }).catch(error => {
      })
    },
    initSysParam() {
      var $this = this;
      $this.setExerciseCount();
    },
    checkTenName(name) {
        if (name.length > 10) {
            return name.substring(0, 10) + "..."
        } else {
            return name
        }
    },
      $totast(msg) {
          this.$toast({message: msg, position: "bottom", duration: 3000, className: 'toastWhite'});
      },
  },
  created() {
    this.innerHeight = window.innerHeight;
    this.initSysParam();
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ExerBasket.vue